var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "10", height: "18", viewBox: "0 0 10 18" }, props),
    React.createElement("path", { fill: "#3B5998", fillRule: "evenodd", d: "M5.662 3.918c0-1.757 3.067-.856 3.067-.856l.4-2.728S7.553-.07 5.662.01C1.768.177 1.903 3.248 1.903 3.248V5.93H0v2.775h1.903V18h3.759V8.705h2.856l.22-2.775H5.661V3.918" })
  );
});